import React from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, CartesianGrid, ResponsiveContainer } from 'recharts';

const dataSource = [
  {
    category: "Животноводческая продукция",
    "2023": 319.2,
    "2024": 769.3,
  },
  {
    category: "Растениеводческая продукция",
    "2023": 279.8,
    "2024": 2596.6,
  },
  {
    category: "Пищевая и перерабатывающая промышленность",
    "2023": 2598.8,
    "2024": 8961.7,
  },
];

const AgriculturalProductsChart = () => {
  return (
    <div style={{ width: '40%', height: 500, margin: '0 auto' }}>
      <h2>Экспорт сельскохозяйственной продукция (тыс. долларов) ,2023-2024,  Январь-Август</h2>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={dataSource} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="category" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar dataKey="2023" fill="#8884d8" name="2023" />
          <Bar dataKey="2024" fill="#82ca9d" name="2024" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default AgriculturalProductsChart;
